// @ts-ignore:next-line
import {useCurrentRefinements} from 'react-instantsearch';
import {IconClose} from '../elements/Icon';
import {useEffect} from 'react';
import {Filters} from './Filters.client';
import {Button, InternalLink} from '..';
import {SanityCollectionTree} from '~/types/sanityTypes';
import {CurrentFilters} from './CurrentFilters';

export function FiltersContainer({
  handle,
  filtersOpen,
  setFiltersOpen,
  peerCollections,
}: {
  handle: string;
  filtersOpen: boolean;
  setFiltersOpen: React.Dispatch<React.SetStateAction<boolean>>;
  peerCollections?: SanityCollectionTree[] | null;
}) {
  const {items} = useCurrentRefinements();

  // Prevent scrolling page when filters are open
  useEffect(() => {
    if (filtersOpen) {
      document.querySelector('body')?.classList.add('filters-open');
    } else {
      document.querySelector('body')?.classList.remove('filters-open');
    }
  }, [filtersOpen]);

  return (
    <div className={`collection-filters-container ${filtersOpen && 'open'}`}>
      <div className="lg:hidden bg-black text-white p-4 flex justify-between">
        <h4 className="m-0">Suodattimet ({items.length})</h4>
        <button onClick={() => setFiltersOpen(false)}>
          <IconClose />
        </button>
      </div>
      <div className="collection-filters">
        <div className="lg:hidden">
          <CurrentFilters />
        </div>
        {peerCollections?.length && (
          <div className="hidden lg:block pb-6 py-2 border-b border-black">
            <h5 className="pb-4 uppercase">Kategoria</h5>
            {peerCollections.map((collection, index) => (
              <div
                key={`peerCollectionNavItem-${index}`}
                className="peer-collection-nav-item"
              >
                <InternalLink
                  documentType="collection"
                  slug={collection.value.slug}
                >
                  {handle === collection.value.slug && (
                    <span className="current-item"></span>
                  )}
                  {collection.value.title}
                </InternalLink>
              </div>
            ))}
          </div>
        )}
        <Filters />
        <div className="lg:hidden">
          <Button className="w-full" onClick={() => setFiltersOpen(false)}>
            Suodata
          </Button>
        </div>
      </div>
    </div>
  );
}
